import { AspectRatio, Box } from '@chakra-ui/react';
import React from 'react';
import { serialize } from './video-serializer';

interface Props {
  url: string;
  title: string;
  small?: boolean;
}

const Video: React.FC<Props> = ({ url, title, small }) => {
  return (
    <AspectRatio maxW={small ? '419px' : '100%'} w="100%" ratio={16 / 9}>
      <Box
        as="iframe"
        title={title}
        borderRadius="15px"
        //@ts-ignore
        src={serialize(url ? url.trim() : '')}
        frameBorder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        data-testid="video-player"
      ></Box>
    </AspectRatio>
  );
};

export default Video;
